module.exports = __webpack_public_path__ + "img/MGH-Nihonbashi-1-2440x1172.cb27a9e7.jpg";